import * as userActions from '../actions/userActions/constants'

const initialState = {
    authorized: false,
    user: null,
    isLoadingUser: true,
    isReferralsLoading: true,
    referrals: null,
    personalInfo: null,
    isPersonalInfoLoading: true,
    isConfirmationProceed: false,
    startTimer: false,
    confirmLoading: true,
    confirmEmailMessage: '',
    isProceedPersonal: false
};

const walletReducer = (state = initialState, action) => {
    switch (action.type) {
        case userActions.AUTHORIZE_REQUEST:
            return {
                ...state,
            };
        case userActions.AUTHORIZE_SUCCESS:
            return {
                ...state,
                authorized: true,
                user: action.payload
            };
        case userActions.AUTHORIZE_FAILURE:
            return {
                ...state,
                authorized: false,
                user: null
            };
        case userActions.DELETE_AUTH_DATA_SUCCESS:
            return {
                ...state,
                authorized: false,
                user: null
            };
        case userActions.GET_USER_REQUEST:
            return {
                ...state,
                isLoadingUser: true
            };
        case userActions.GET_USER_SUCCESS:
            return {
                ...state,
                isLoadingUser: false,
                user: action.payload
            };
        case userActions.GET_USER_FAILURE:
            return {
                ...state,
                isLoadingUser: false,
                user: null
            };
        case userActions.GET_USER_REFERRALS_REQUEST:
            return {
                ...state,
                isReferralsLoading: true,
            };
        case userActions.GET_USER_REFERRALS_SUCCESS:
            return {
                ...state,
                isReferralsLoading: false,
                referrals: action.payload
            };
        case userActions.GET_USER_REFERRALS_FAILURE:
            return {
                ...state,
                isReferralsLoading: false,
                referrals: null
            };
        case userActions.GET_PERSONAL_INFO_REQUEST:
            return {
                ...state,
                isPersonalInfoLoading: true,
            };
        case userActions.GET_PERSONAL_INFO_SUCCESS:
            return {
                ...state,
                isPersonalInfoLoading: false,
                personalInfo: {
                    first_name: action.payload.user_name.first_name,
                    last_name: action.payload.user_name.last_name,
                    phone_number: action.payload.phone_number,
                    email: action.payload.email,
                    country: action.payload.country,
                    public_id: action.payload.public_id,
                    is_email_confirmed: action.payload.is_email_confirmed
                }
            };
        case userActions.GET_PERSONAL_INFO_FAILURE:
            return {
                ...state,
                isPersonalInfoLoading: false,
                personalInfo: null
            };
        case userActions.USER_UPDATE_PERSONAL_INFO_REQUEST:
            return {
                ...state,
                isProceedPersonal: true,
            };
        case userActions.USER_UPDATE_PERSONAL_INFO_SUCCESS:
            return {
                ...state,
                isProceedPersonal: false,
            };
        case userActions.USER_UPDATE_PERSONAL_INFO_FAILURE:
            return {
                ...state,
                isProceedPersonal: false,
            };
        case userActions.SEND_CONFIRM_EMAIL_LINK_REQUEST:
            return {
                ...state,
                isConfirmationProceed: true,
            };
        case userActions.SEND_CONFIRM_EMAIL_LINK_SUCCESS:
            return {
                ...state,
                isConfirmationProceed: false,
                startTimer: true
            };
        case userActions.SEND_CONFIRM_EMAIL_LINK_FAILURE:
            return {
                ...state,
                isConfirmationProceed: false,
            };
        case userActions.END_TIMER:
            return {
                ...state,
                startTimer: false,
            };
        case userActions.USER_CONFIRM_EMAIL_ACTION_REQUEST:
            return {
                ...state,
                confirmLoading: true,
            };
        case userActions.USER_CONFIRM_EMAIL_ACTION_SUCCESS:
            return {
                ...state,
                confirmLoading: false,
                confirmEmailMessage: 'Your email has been confirmed!'
            };
        case userActions.USER_CONFIRM_EMAIL_ACTION_FAILURE:
            return {
                ...state,
                confirmLoading: false,
                confirmEmailMessage: action.payload || 'Incorrect information or the link is out of date. Log in to your account and send a new confirmation request.'
            };
        case userActions.CLEAR_PERSONAL:
            return {
                ...state,
                personalInfo: null
            };
        default:
            return state
    }
}

export default walletReducer